export default {
  strings: {
    chooseFiles: 'Choose files',
  },
}
